
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.86.555v8.492l1.382-1.172.43.508-3.735 3.742h-.5L.704 8.383l.43-.508L2.5 9.039V.555h1.11v9.36l1.078.866L5.75 9.93V.555h1.11z","fill":"currentColor"}})])
          )
        }
      }
    